export default __webpack_public_path__ + "static/media/login.ebfb7a9e.jpg";